import { Component  } from '@angular/core';

/**
    * Generic dialog box which displays the customised content
    * */
@Component({
  selector: 'app-loader',
  template: `
  <div class="d-flex flex-column loader">
  <div class="loader-cube loader-cube1"></div>
  <div class="loader-cube loader-cube2"></div>
  <div class="loader-cube loader-cube3"></div>
  <div class="loader-cube loader-cube4"></div>
  <div class="loader-cube loader-cube5"></div>
  <div class="loader-cube loader-cube6 row2color"></div>
  <div class="loader-cube loader-cube7 row2color"></div>
  <div class="loader-cube loader-cube8 row2color"></div>
  <div class="loader-cube loader-cube9 row2color"></div>
  <div class="loader-cube loader-cube10 row2color"></div>
  <div class="loader-cube loader-cube11 row3color"></div>
  <div class="loader-cube loader-cube12 row3color"></div>
  <div class="loader-cube loader-cube13 row3color"></div>
  <div class="loader-cube loader-cube14 row3color row-red"></div>
  <div class="loader-cube loader-cube15 row3color"></div>
  <div class="loader-cube loader-cube16 row4color row-blue"></div>
  <div class="loader-cube loader-cube17 row4color"></div>
  <div class="loader-cube loader-cube18 row4color"></div>
  <div class="loader-cube loader-cube19 row4color"></div>
  <div class="loader-cube loader-cube20 row4color"></div>
  <div class="loader-cube loader-cube21 row5color"></div>
  <div class="loader-cube loader-cube22 row5color"></div>
  <div class="loader-cube loader-cube23 row5color row-blue"></div>
  <div class="loader-cube loader-cube24 row5color"></div>
  <div class="loader-cube loader-cube25 row5color row-red"></div>
</div>`
})
export class LoaderComponent {
  constructor() { }

}
